const Routes = [];

/*** PUBLIC RULES */
Routes.push({
    path: "/m-inbox",
    meta: {},
    name: "m-inbox",
    component: () => import("@/modules/minbox/RootView")
});

export default Routes;